var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUpRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8424 6.12971V9.70674C21.8424 10.0345 21.5623 10.3062 21.2205 10.3062C20.8844 10.3118 20.6043 10.0429 20.5987 9.70674V7.88321L15.1281 15.4238C14.9572 15.6619 14.6435 15.7488 14.3746 15.6311L7.1757 12.5695L3.31576 19.1717C3.20371 19.3622 2.99923 19.4771 2.77794 19.4743C2.6715 19.4743 2.56786 19.449 2.46982 19.4014C2.18131 19.2474 2.07206 18.8888 2.22612 18.6003C2.23173 18.5919 2.23453 18.5835 2.24013 18.5779L6.37178 11.5135C6.53425 11.2418 6.87038 11.1325 7.1589 11.2586L14.4054 14.337L19.9292 6.73476H17.5763C17.2401 6.74036 16.96 6.47145 16.9544 6.13532V6.13251C16.9544 5.79638 17.2289 5.53027 17.5763 5.53027H21.2205C21.5595 5.53027 21.8424 5.79358 21.8424 6.12971Z",
    fill: "#0B2739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUpRegular);
export default __webpack_public_path__ + "static/media/trend-up-regular.ec0554bca980b7754e404f9cf9d24f0c.svg";
export { ForwardRef as ReactComponent };